import { fetchPhotonApi } from '@/domain/position-geocode/utils/search-geocode/photon-api';
import { PhotonFeature } from '@/domain/position-geocode/utils/search-geocode/photon-api.dto';
import { mapPhotonFeatureToPosition } from '@/domain/position-geocode/utils/search-geocode/photon-api-mapper-to-position-geocode';

import { Option } from '../FSPositionGeocodeField';

export async function fetchOptionsFromApiPhoton(
  query: string,
): Promise<Option[]> {
  const features: PhotonFeature[] = await fetchPhotonApi(query);
  const options: Option[] = convertPhotonFeatureToOption(features);
  return options;
}

function convertPhotonFeatureToOption(features: PhotonFeature[]): Option[] {
  const options = features.map<Option>((f) => {
    return {
      key: f.properties.osm_id + f.properties.osm_type,
      position: mapPhotonFeatureToPosition(f),
    };
  });
  return options;
}
